import { getProgress as getProgressM } from "../mock/MockProgress";

export const getProgress = async () => {
    return await getProgressM();

    //use API
};